import { useContext } from 'react';

import { TrackingContext } from '../TrackingContext';

/** Use Google Tag Manager tracking methods */
export const useTracking = () => useContext(TrackingContext);
